/// <reference types="vite/client" />

import { ApiClient } from './ApiClient';
import { CompanyDataSource } from './account/datasources/CompanyDataSource';
import { SalesRepository } from './sales/repositories/SalesRepository';
import { SalesDataSource } from './sales/datasources/SalesDataSource';
import { ProductRepository } from './product/repositories/ProductRepository';
import { ProductDataSource } from './product/datasources/ProductDataSource';
import { CollectionRepository } from './product/repositories/CollectionRepository';
import { CollectionDataSource } from './product/datasources/CollectionDataSource';
import { CustomFieldRepository } from './product/repositories/CustomFieldRepository';
import { CustomFieldDataSource } from './product/datasources/CustomFieldDataSource';
import { CompanyRepository } from './account/repositories/CompanyRepository';
import { WarehouseRepository } from './inventory/repositories/WarehouseRepository';
import { WarehouseDataSource } from './inventory/datasources/WarehouseDataSource';
import { AuthRepository } from './account/repositories/AuthRepository';
import { AuthDataSource } from './account/datasources/AuthDataSource';
import { ConnectionsRepository as ConnectionsRepository } from './connection/repositories/MarketplaceRepository';
import { ConnectionsDataSource } from './connection/datasources/MarketplaceDataSource';
import { account } from '../application/context/Appwrite';
import { InventoryRepository } from './inventory/repositories/InventoryRepository';
import { InventoryDataSource } from './inventory/datasources/InventoryDataSource';
import { WarehouseConnectionRepository } from './inventory/repositories/WarehouseConnectionRepository';
import { InsightsDataSource } from './insights/datasources/InsightsDataSource';
import { InsightsRepository } from './insights/repositories/InsightsRepository';
import { WarehouseConnectionDataSource } from './inventory/datasources/WarehouseConnectionDataSource';
import { BolConnectorRepository } from './connection/repositories/BolConnectorRepository';
import { BolConnectorDataSource } from './connection/datasources/BolConnectorDataSource';
import { MontaConnectorRepository } from './connection/repositories/MontaConnectorRepository';
import { MontaConnectorDataSource } from './connection/datasources/MontaConnectorDataSource';
import { PurchasingRepository } from './purchasing/repositories/PurchasingRepository';
import { PurchasingDataSource } from './purchasing/datasources/PurchasingDataSource';
import { SupplierRepository } from './suppliers/repositories/SupplierRepository';
import { SupplierDataSource } from './suppliers/datasources/SupplierDataSource';
import { ShipmentRepository } from './purchasing/repositories/ShipmentRepository';
import { ShipmentDataSource } from './purchasing/datasources/ShipmentDataSource';
import { NotesRepository } from './purchasing/repositories/NotesRepository';
import { NotesDataSource } from './purchasing/datasources/NotesDataSource';
import { SubscriptionRepository } from './subscription/SubscriptionRepository';
import { ForecastRepository } from './forecast/repositories/ForecastRepository';
import { ForecastDataSource } from './forecast/datasources/ForecastDataSource';
import { EventRepository } from './events/repositories/EventRepository';
import { EventDataSource } from './events/datasources/EventDataSource';
import { TaskRepository } from './tasks/repositories/TaskRepository';
import { TaskDataSource } from './tasks/datasources/TaskDataSource';
import { Import4YouConnectorRepository } from './connection/repositories/Import4YouConnectorRepository';
import { Import4YouConnectorDataSource } from './connection/datasources/Import4YouConnectorDataSource';
import { ProductFlowConnectorRepository } from './connection/repositories/ProductFlowConnectorRepository';
import { ProductFlowConnectorDataSource } from './connection/datasources/ProductFlowConnectorDataSource';
import { WooCommerceConnectorRepository } from './connection/repositories/WooCommerceConnectorRepository';
import { WooCommerceConnectorDataSource } from './connection/datasources/WooCommerceConnectorDataSource';
import { ShopifyConnectorRepository } from './connection/repositories/ShopifyConnectorRepository';
import { ShopifyConnectorDataSource } from './connection/datasources/ShopifyConnectorDataSource';
import { AmazonConnectorRepository } from './connection/repositories/AmazonConnectorRepository';
import { AmazonConnectorDataSource } from './connection/datasources/AmazonConnectorDataSource';
import { ChannelDockConnectorRepository } from './connection/repositories/ChannelDockConnectorRepository';
import { ChannelDockConnectorDataSource } from './connection/datasources/ChannelDockConnectorDataSource';
import { ImportJobsRepository } from './connection/repositories/ImportJobsRepository';
import { ImportJobsDataSource } from './connection/datasources/ImportJobsDataSource';

// Initialize core services
const api = new ApiClient(import.meta.env.VITE_API_URL);

export const container = {
    authRepository: new AuthRepository(
        new AuthDataSource(api, account)
    ),
    salesRepository: new SalesRepository(
        new SalesDataSource(api)
    ),
    productRepository: new ProductRepository(
        new ProductDataSource(api)
    ),
    collectionRepository: new CollectionRepository(
        new CollectionDataSource(api)
    ),
    customFieldRepository: new CustomFieldRepository(
        new CustomFieldDataSource(api)
    ),
    companyRepository: new CompanyRepository(
        new CompanyDataSource(api)
    ),
    warehouseRepository: new WarehouseRepository(
        new WarehouseDataSource(api)
    ),
    inventoryRepository: new InventoryRepository(
        new InventoryDataSource(api)
    ),
    marketplaceRepository: new ConnectionsRepository(
        new ConnectionsDataSource(api)
    ),
    warehouseConnectionRepository: new WarehouseConnectionRepository(
        new WarehouseConnectionDataSource(api)
    ),
    insightsRepository: new InsightsRepository(
        new InsightsDataSource(api)
    ),
    bolConnectorRepository: new BolConnectorRepository(
        new BolConnectorDataSource(api)
    ),
    montaConnectorRepository: new MontaConnectorRepository(
        new MontaConnectorDataSource(api)
    ),
    import4YouConnectorRepository: new Import4YouConnectorRepository(
        new Import4YouConnectorDataSource(api)
    ),
    productFlowConnectorRepository: new ProductFlowConnectorRepository(
        new ProductFlowConnectorDataSource(api)
    ),
    wooCommerceConnectorRepository: new WooCommerceConnectorRepository(
        new WooCommerceConnectorDataSource(api)
    ),
    shopifyConnectorRepository: new ShopifyConnectorRepository(
        new ShopifyConnectorDataSource(api)
    ),
    amazonConnectorRepository: new AmazonConnectorRepository(
        new AmazonConnectorDataSource(api)
    ),
    channeldockConnectorRepository: new ChannelDockConnectorRepository(
        new ChannelDockConnectorDataSource(api)
    ),
    importJobsRepository: new ImportJobsRepository(
        new ImportJobsDataSource(api)
    ),
    purchasingRepository: new PurchasingRepository(
        new PurchasingDataSource(api)
    ),
    supplierRepository: new SupplierRepository(
        new SupplierDataSource(api)
    ),
    shipmentRepository: new ShipmentRepository(
        new ShipmentDataSource(api)
    ),
    notesRepository: new NotesRepository(
        new NotesDataSource(api)
    ),
    subscriptionRepository: new SubscriptionRepository(api),
    forecastRepository: new ForecastRepository(
        new ForecastDataSource(api)
    ),
    eventRepository: new EventRepository(
        new EventDataSource(api)
    ),
    taskRepository: new TaskRepository(
        new TaskDataSource(api)
    ),
}; 